import { ActivityDifficulty } from "../domain";

export const activityDifficultyInNumber = {
  [ActivityDifficulty.Easy]: 1,
  [ActivityDifficulty.Medium]: 2,
  [ActivityDifficulty.Hard]: 3
}